import { GenericResponse } from 'src/app/interfaces/main';

export const KakaoSyncLocalStorageKey = 'kakao_sync_started';

export enum KakaoStatus {
  LOGIN_NEEDED = 'LOGIN_NEEDED',
  ERROR = 'ERROR',
  SUCCEED = 'SUCCEED'
}

export interface KakaoFriend {
  favorite: boolean;
  id: number;
  profileNickname: string;
  profileThumbnailImage: string;
  uuid: string;
}

export interface KakaoPluginResponse {
  value: any;
}

export interface KakaoInitializeResponse {
  status: KakaoStatus;
}

export interface KakaoScope {
  agreed: boolean;
  displayName: string;
  id: string;
  revocable: boolean;
  type: string;
  using: boolean;
}

export interface KakaoToken {
  accessToken: string;
  refreshToken: string;
}

export interface KakaoShareData {
  title: string;
  description: string;
  imageUrl: string;
  imageWidth?: number;
  imageHeight?: number;
  imageLinkUrl: string;
  buttonTitle: string;
}

export interface KakaoSyncTerms {
  userId: number; // kakao uid
  allowedServiceTerms: {
    tag: string;
    agreedAt: string;
  }[];
  appServiceTerms: {
    tag: string;
    createdAt: string;
    updatedAt: string;
  }[]
}

export interface KakaoSyncTermsResponse extends GenericResponse {
  data: KakaoSyncTerms;
}

export interface IsKakaoPhoneAgreedResponse extends GenericResponse {
  data: { isAgreed: boolean };
}